import React from 'react';
import { HpiCheckLogo } from '../../common/style';

const HPILogo: React.FC = () => <HpiCheckLogo />;

export default HPILogo;
